import { useContext } from 'react';
import { FeatureFlagsContext } from '@core-ui/feature-flags';

const useEnabledFeature = (feature: string): boolean => {
  const { enabledFeatures } = useContext(FeatureFlagsContext);

  return Boolean(enabledFeatures?.[feature]);
};

export default useEnabledFeature;
